<template>
  <Card
    :pt="{
      root: {
        style: 'height: 310px; width: 220px; user-select: none;',
      },
      body: {
        style: 'padding: 0; cursor:pointer;',
      },
      content: {
        style: 'padding: 0;',
      },
    }"
    @click.stop="handleClick"
  >
    <template #content>
      <div :class="$style.cardWrapper">
        <img :src="plusImage" alt="Add item" width="168" height="64" />
        <p :class="$style.buttonText">Add products</p>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import plusImage from "@/assets/plus.png";
import Card from "primevue/card";

const emits = defineEmits(["show-modal"]);

const handleClick = () => {
  emits("show-modal");
};
</script>

<style module lang="scss">
.cardWrapper {
  width: 220px;
  height: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.buttonText {
  font-size: 16px;
  font-weight: 700;
  color: var(--vd-color-text-default);
}
</style>
